import MultipleChoice from './MultipleChoice';

export default MultipleChoice;
